'use client';

import * as DS from '@aurorasolar/ds';

export const EndMark = () => (
  <DS.Text color="uiHelperCopy" mt={4}>
    # # #
  </DS.Text>
);
